import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notificationsPageTitle: {
		defaultMessage: 'Project and issue notifications',
		id: 'personal-settings-notifications.notifications-page-title',
		description: 'Title for notifications page',
	},
	notificationsExplanation: {
		defaultMessage:
			'Control when you receive email or in-product notifications from Jira. You can change these settings at any time. ',
		id: 'personal-settings-notifications.notifications-explanation',
		description: 'Explanation for notifications page',
	},
	notificationsSettingsHelper: {
		defaultMessage: 'Learn more about managing your notifications.',
		id: 'personal-settings-notifications.notifications-settings-helper',
		description: 'Helper text for notifications page',
	},
	notificationProjectSettingsHeading: {
		defaultMessage: 'Customize project notifications',
		id: 'personal-settings-notifications.notification-project-settings-heading',
		description: 'Heading for project notifications section',
	},
	notificationProjectSettingsDescription: {
		defaultMessage:
			'Make your notifications specific to your project needs. Choose a project to set customized notifications.',
		id: 'personal-settings-notifications.notification-project-settings-description',
		description: 'Description for project notifications section',
	},
	notificationProjectSettingsAddProjectNotificationsButtonText: {
		defaultMessage: 'Add project notifications',
		id: 'personal-settings-notifications.notification-project-settings-add-project-notifications-button-text',
		description: 'Button text for Adding project notifications',
	},
	notificationEmailPreferencesHeading: {
		defaultMessage: 'Email preferences',
		id: 'personal-settings-notifications.notification-email-preferences-heading',
		description: 'Heading for email preferences section',
	},
	notificationEmailPreferencesDescriptionWithBatching: {
		defaultMessage:
			'Tell us what kind of email updates you want to receive, and how often we should send you notifications via email.',
		id: 'personal-settings-notifications.notification-email-preferences-description-with-batching',
		description: 'Heading for email preferences section',
	},
	notificationsPageTitleIssueTermRefresh: {
		defaultMessage: 'Notifications for projects and work items',
		id: 'personal-settings-notifications.notifications-page-title-issue-term-refresh',
		description: 'Title for notifications page',
	},
});
